__webpack_require__.p = "/pxdisk/";